module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_hy130@2x.b0091f60.png";